import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertConfig } from '../../services/alert-modal.service';

@Component({
  selector: 'alert-popup',
  templateUrl: './alertPopup.component.html',
  styleUrls: ['./alertPopup.component.scss']
})
export class alertPopupComponent implements OnInit {
  @Input() config: AlertConfig;

  // Legacy inputs kept for any remaining inline usages
  @Input() alterMessage: string;
  @Input() showCancel: string;
  @Input() successButtonText: string;

  @Output() onAlertSuccess = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();

  get title(): string {
    return (this.config && this.config.title) ? this.config.title : 'Confirm';
  }
  get message(): string {
    return (this.config && this.config.message !== undefined) ? this.config.message : (this.alterMessage || '');
  }
  get cancelLabel(): string {
    const v = this.config ? this.config.cancelText : this.showCancel;
    return v !== undefined ? v : 'No';
  }
  get confirmLabel(): string {
    const v = this.config ? this.config.confirmText : this.successButtonText;
    return v !== undefined ? String(v) : '';
  }

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}

  onSuccess() {
    this.onAlertSuccess.emit();
    this.activeModal.close(true);
  }

  closeModal() {
    this.onCancel.emit();
    this.activeModal.close(false);
  }
}
